module.exports = __webpack_public_path__ + "img/img_elanco_logo.9ba68364.svg";